import React, { Component } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Grid,
} from "@material-ui/core";

import { xencallService } from "../services";
import { MigrateClient } from "./MigrateClient";
import { ManageClient } from "./ManageClient";
import XCSearch from "./XCSearch";

class Clients extends Component {
  constructor() {
    super();
    this.state = {
      admin: true,
      clients: [],
      view: "list_customers",
      customerPortalUrl: null,
      client: null,
      matching: '',
    };
    this.cancel = this.cancel.bind(this);
    this.refresh = this.refresh.bind(this);
  }

  preventDefault(event) {
    event.preventDefault();
  }

  componentDidMount() {
    xencallService.getStripeCustomers(this);
  }
  componentDidUpdate(prevProps, prevState) {
    console.log("componentDidUpdate", prevState, prevProps);
    if (prevProps.name !== this.props.name) {
      this.handleUpdateName();
    }
  }

  handleUpdateName = () => {
    this.setState({ clients: [], view: "list_customers" });
    xencallService.getStripeCustomers(this);
  };

  viewClient(client) {
    const { migrated } = this.props;
    console.log(
      "viewClient",
      migrated ? "Migrated" : "Not Migrated Yet",
      client
    );
    this.setState({
      //view: migrated ? "manage" : "migrate",
      view: "portal",
      client: client
    });
  }

  viewPortal(client) {
    console.log(
      "viewPortal",
      client
    );
    xencallService.getCustomerPortalUrl(this, client.id);
    /*
    this.setState({
      //view: migrated ? "manage" : "migrate",
      view: "portal",
      client: client
    });
    */
  }

  cancel() {
    const { migrated } = this.props;
    console.log("cancel", migrated ? "Migrated" : "Not Migrated Yet");
    this.setState({
      view: "list_customers"
    });
  }

  refresh() {
    const { migrated } = this.props;
    console.log("refresh", migrated ? "Migrated" : "Not Migrated Yet");
    this.setState({
      view: "list_customers"
    });
    //xencallService.getClients(this, migrated);
    xencallService.getStripeCustomers(this);
  }

  filter = (matching) => {
    console.log('filter');
    console.log(matching);
    this.setState({ matching: matching });
  }

  search = (matching) => {
    console.log('search');
    console.log(matching);
  }



  render() {
    const { clients, view, client, customerPortalUrl, admin, matching } = this.state;
    const { migrated } = this.props;

    if (customerPortalUrl) {
      console.log('Redirect to customer Portal Url', customerPortalUrl);
      window.location.href = customerPortalUrl;
    }
    if (!admin) {
      console.log('Redirect to customer Portal Url for client');
      //xencallService.getCustomerPortalUrl(this, 0);
    }

    const filteredRecords = (matching && matching.length > 0) ? clients.filter(o =>
      Object.keys(o).some(k => String(o[k]).toLowerCase().includes(matching.toLowerCase()))) : clients;

    const migratedClients = filteredRecords.filter(c => { return (c.stripeId && c.stripeId.length > 0) });

    console.log("clients", migrated ? "Migrated" : "Not Migrated Yet", filteredRecords);
    console.log(migratedClients)
    console.log(view)
    return (
      <div>
        <Grid justify="space-between" container >
          <Grid item xs={12}>
            <XCSearch
              customStyle={{ padding: 0, margin: '5px 0px', width: '100%', }}
              label="Customes"
              display="NAME"
              value="XYZ"
              fieldName="F"
              filter={this.filter}
              search={this.search}
              onDelete={() => console.log('CouCOu')}
            />
          </Grid>
        </Grid>
        <React.Fragment>
          {view === "list" && !migrated && (
            <div>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell>Id</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredRecords.map(client => (
                    <TableRow
                      key={client.id}
                      onClick={() => this.viewClient(client)}
                    >
                      <TableCell>{client.name}</TableCell>
                      <TableCell>{client.id}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          )}
          {view === "list_customers" && migrated && (
            <div>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>XenCall Id</TableCell>
                    <TableCell>Salesforce Id</TableCell>
                    <TableCell>Stripe Id</TableCell>
                    <TableCell>Name</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {migratedClients.map(client => (
                    <TableRow
                      key={client.id}
                      onClick={() => this.viewClient(client)}
                    >
                      <TableCell>{client.id}</TableCell>
                      <TableCell>{client.sfdcId}</TableCell>
                      <TableCell>{client.stripeId}</TableCell>
                      <TableCell>{client.name}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          )}
          {view === "list_customers" && !migrated && (
            <div>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>XenCall Id</TableCell>
                    <TableCell>Salesforce Id</TableCell>
                    <TableCell>Stripe Id</TableCell>
                    <TableCell>Name</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredRecords.map(client => (
                    <TableRow
                      key={client.id}
                      onClick={() => this.viewPortal(client)}
                    >
                      <TableCell>{client.id}</TableCell>
                      <TableCell>{client.sfdcId}</TableCell>
                      <TableCell>{client.stripeId}</TableCell>
                      <TableCell>{client.name}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          )}
          {view === "migrate" && (
            <div>
              <MigrateClient
                client={client}
                cancel={this.cancel}
                refresh={this.refresh}
              />
            </div>
          )}
          {view === "manage" && (
            <div>
              <ManageClient
                client={client}
                cancel={this.cancel}
                refresh={this.refresh}
              />
            </div>
          )}
        </React.Fragment>
      </div>
    );
  }
}

export { Clients };
